// Button actions and utilities for smooth interactions

// Smooth scroll to section
export const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
};

// WhatsApp contact function
export const contactWhatsApp = (message = 'Hi, I would like to inquire about your signage services at Aim Flex.') => {
  const phoneNumber = '919943281483'; // Without + and spaces
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  window.open(whatsappUrl, '_blank');
};

// Phone call function
export const makePhoneCall = (phoneNumber = '+919943281483') => {
  window.open(`tel:${phoneNumber}`, '_self');
};

// Email function
export const sendEmail = (email = 'info@aimscreenprints.com', subject = 'Inquiry about Signage Services') => {
  const encodedSubject = encodeURIComponent(subject);
  window.open(`mailto:${email}?subject=${encodedSubject}`, '_self');
};

// Google Maps function
export const openGoogleMaps = () => {
  window.open('https://maps.app.goo.gl/W5WaQEr5juLVAd1px', '_blank');
};

// Quote form handler
export const handleQuoteRequest = (serviceType = 'General Inquiry') => {
  const message = `Hi, I would like to request a quote for ${serviceType}. Please contact me with more details.`;
  contactWhatsApp(message);
};

// Portfolio view function
export const viewPortfolio = () => {
  scrollToSection('portfolio');
};

// Service inquiry function
export const inquireAboutService = (serviceName) => {
  const message = `Hi, I'm interested in your ${serviceName} services. Could you provide more information and pricing?`;
  contactWhatsApp(message);
};

// Button click animation
export const addClickAnimation = (element) => {
  element.style.transform = 'scale(0.95)';
  setTimeout(() => {
    element.style.transform = 'scale(1)';
  }, 150);
};

// Newsletter subscription (mock)
export const subscribeNewsletter = async (email) => {
  // Simulate API call
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  console.log('Newsletter subscription:', email);
  return {
    success: true,
    message: 'Thank you for subscribing to our newsletter!'
  };
};

// Filter portfolio
export const filterPortfolio = (category, setActiveFilter) => {
  setActiveFilter(category);
  
  // Add smooth animation class
  const portfolioGrid = document.querySelector('[data-portfolio-grid]');
  if (portfolioGrid) {
    portfolioGrid.style.opacity = '0.7';
    setTimeout(() => {
      portfolioGrid.style.opacity = '1';
    }, 300);
  }
};